import { render, staticRenderFns } from "./OsAguardandoAprovacao.vue?vue&type=template&id=e3fde3cc&"
import script from "./OsAguardandoAprovacao.vue?vue&type=script&lang=js&"
export * from "./OsAguardandoAprovacao.vue?vue&type=script&lang=js&"
import style0 from "./OsAguardandoAprovacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports